import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from 'src/app/users/users.service';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { NocConfigurationService } from '../noc-configuration.service';
import { CommonDataService } from 'src/app/shared/services/common-data.service';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { ValidationService } from 'src/app/shared/services/validation.service';
import validationRulesModel from '../../../../../../iotah-common/validations/validationRules.json';

@Component({
	selector: 'app-noc-configuration-edit',
	templateUrl: './noc-configuration-edit.component.html',
	styleUrls: ['./noc-configuration-edit.component.css']
})
export class NocConfigurationEditComponent implements OnInit {
	@ViewChild('nocConfigForm') nocConfigForm!: NgForm;

	isEditMode: boolean = false;
	configId: number = 0;
	validationRules: any = {};

	config: any = {
		meter_number: '',
		power_view_sn: '',
		is_feeder_meter: 1,
		is_meter_subtracting: 0,
		ct_ratio: 100,
		wiring_mode: 3,
		nominal_voltage: 120,
		empty_nbiot_bands: true
	};

	// Get dropdown options from CommonDataService
	feederMeterOptions = this.commonDataService.feederMeterOptions;
	accumulatingOptions = this.commonDataService.accumulatingOptions;
	ctRatioOptions = [...this.commonDataService.ctRatioOptions, ...this.commonDataService.ctRatioRogowskiType];
	wiringModeOptions = this.commonDataService.wiringModeOptions;
	nominalVoltageOptions = this.commonDataService.nominalVoltageOptions;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private translateService: TranslateService,
		private usersService: UsersService,
		private nocConfigService: NocConfigurationService,
		private sideMenuService: SideMenuService,
		private commonDataService: CommonDataService,
		private notificationMessage: NotificationMessageService,
		private validationService: ValidationService
	) {}

	ngOnInit() {
		if (!this.usersService.hasAccessPermission(null, 'noc'))
			this.router.navigate(['/unauthorized']);

		this.sideMenuService.hide();

		this.validationRules = validationRulesModel.nocConfiguration;

		this.route.params.subscribe(params => {
			const action = params['action'];
			const id = params['id'];

			if (action === 'edit' && id) {
				this.isEditMode = true;
				this.configId = parseInt(id);
				this.loadConfiguration();
			}
		});
	}

	loadConfiguration() {
		this.nocConfigService.getNocConfiguration(this.configId).subscribe((response: any) => {
			if (response.config) {
				this.config = response.config.config;
			} else {
				this.notificationMessage.setMessage('g.failed', { clearOnXTimeNavigate: 1 });
				this.goBack();
			}
		});
	}

	getNominalVoltageLabel(): string {
		const wiringMode = this.config.wiring_mode;
		// 3-phase modes (0, 1) use L-L, single phase modes (2, 3) use L-N
		return [0, 1, 2].includes(wiringMode) ? 'L-L' : 'L-N';
	}
	
	onSubmit() {
		const configData = {
			config: this.config
		};

		this.nocConfigService.saveNocConfiguration(this.configId, configData).subscribe((response: any) => {
			if (response === 1) {
				this.notificationMessage.setMessage(
					this.isEditMode ? 'g.saved_successfully' : 'g.created_successfully',
					{ type: 'success', clearOnXTimeNavigate: 1 }
				);
				this.goBack();
			} else {
				this.notificationMessage.setMessage('g.failed', { clearOnXTimeNavigate: 1 });
			}
		});
	}

	goBack() {
		this.router.navigate(['/noc-tools/noc-configurations']);
	}
}
